import { render } from "./MyWallet.vue?vue&type=template&id=7210f34c&scoped=true"
import script from "./MyWallet.vue?vue&type=script&lang=js"
export * from "./MyWallet.vue?vue&type=script&lang=js"

import "./MyWallet.vue?vue&type=style&index=0&id=7210f34c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7210f34c"]])

export default __exports__